const wwTitlebarKey = 'fiton:local:wwtitlebar'
const wwUserIdKey = 'fiton:local:wwUserId'
const wwClientIdKey = 'fiton:local:wwClientId'
const wwClientSecretKey = 'fiton:local:wwClientSecret'
const wwActivityLevelKey = 'fiton:local:wwActivityLevel'
const wwAgeKey = 'fiton:local:wwAgeKey'
const wwBmiKey = 'fiton:local:wwBmiKey'
const wwGenderKey = 'fiton:local:wwGenderKey'
const wwHeightKey = 'fiton:local:wwHeightKey'
const wwWeightKey = 'fiton:local:wwWeightKey'
const wwFeaturesKey = 'fiton:local:wwFeaturesKey'
const wwDisclaimerKey = 'fiton:local:wwDisclaimerNewKey'
const wwNewChallengeKey = 'fiton:local:wwNewChallengeKey'
const currentLanguageKey = 'fiton:local:currentLanguage'
const partnerCategoryListKey = 'fiton:local:partnerCategoryList'
const zumbaPreviewStartDate = 'fiton:local:zumbapreview:startdate'
const firstOpenKey = 'fiton:local:first:open'

const cacheClientInfo = { clientId: '', clientSecret: '' }

export const setWWTitlebar = (value) => {
  return localStorage.setItem(wwTitlebarKey, value)
}

export const showWWTitlebar = () => {
  return localStorage.getItem(wwTitlebarKey) === '1'
}

export const setWWUserId = (userId) => {
  return localStorage.setItem(wwUserIdKey, userId)
}

export const getWWUserId = () => {
  return localStorage.getItem(wwUserIdKey)
}

export const setWWClientId = (clientId) => {
  cacheClientInfo.clientId = clientId
  return localStorage.setItem(wwClientIdKey, clientId)
}

export const getWWClientId = () => {
  try {
    return localStorage.getItem(wwClientIdKey) || cacheClientInfo.clientId
  } catch (e) {
    return cacheClientInfo.clientId
  }
}

export const setWWClientSecret = (clientSecret) => {
  cacheClientInfo.clientSecret = clientSecret
  return localStorage.setItem(wwClientSecretKey, clientSecret)
}

export const getWWClientSecret = () => {
  try {
    return (
      localStorage.getItem(wwClientSecretKey) || cacheClientInfo.clientSecret
    )
  } catch (e) {
    return cacheClientInfo.clientSecret
  }
}

export const setWWActivityLevel = (activityLevel) => {
  return localStorage.setItem(wwActivityLevelKey, activityLevel)
}

export const getWWActivityLevel = () => {
  return localStorage.getItem(wwActivityLevelKey)
}

export const setWWAge = (age) => {
  return localStorage.setItem(wwAgeKey, age)
}

export const getWWAge = () => {
  return localStorage.getItem(wwAgeKey)
}

export const setWWBmi = (bmi) => {
  return localStorage.setItem(wwBmiKey, bmi)
}

export const getWWBmi = () => {
  return localStorage.getItem(wwBmiKey)
}
export const setWWGender = (gender) => {
  return localStorage.setItem(wwGenderKey, gender)
}

export const getWWGender = () => {
  return localStorage.getItem(wwGenderKey)
}

export const setWWHeight = (height) => {
  return localStorage.setItem(wwHeightKey, height)
}

export const getWWHeight = () => {
  return localStorage.getItem(wwHeightKey)
}

export const setWWWeight = (weight) => {
  return localStorage.setItem(wwWeightKey, weight)
}

export const getWWWeight = () => {
  return localStorage.getItem(wwWeightKey)
}

export const setWWDisclaimer = (showDisclaimer) => {
  return localStorage.setItem(wwDisclaimerKey, showDisclaimer)
}

export const getWWDisclaimer = () => {
  return localStorage.getItem(wwDisclaimerKey)
}

export const setWWNewChallenge = (showNewChallengeKey) => {
  return localStorage.setItem(wwNewChallengeKey, showNewChallengeKey)
}

export const getWWNewChallenge = () => {
  return localStorage.getItem(wwNewChallengeKey)
}

export const setCurrentLanguage = (currentLanguage) => {
  return localStorage.setItem(currentLanguageKey, currentLanguage)
}

export const getCurrentLanguage = () => {
  return localStorage.getItem(currentLanguageKey)
}
export const getWWFeatures = () => {
  return localStorage.getItem(wwFeaturesKey)
}
export const setWWFeatures = (features) => {
  return localStorage.setItem(wwFeaturesKey, features)
}
export const getZumbaPreviewStartDate = () => {
  return localStorage.getItem(zumbaPreviewStartDate)
}
export const setZumbaPreviewStartDate = (features) => {
  return localStorage.setItem(zumbaPreviewStartDate, features)
}
export const getAppFirstOpen = () => {
  const key = localStorage.getItem(firstOpenKey)
  return key !== 'false'
}
export const setAppFirstOpen = (firstOpen) => {
  return localStorage.setItem(firstOpenKey, firstOpen)
}

export const getPartnerCategoryList = () => {
  let output = localStorage.getItem(partnerCategoryListKey)
  try {
    output = JSON.parse(output) || []
  } catch (e) {
    output = []
  }
  return output
}
export const savePartnerCategoryList = (categoryList) => {
  return localStorage.setItem(
    partnerCategoryListKey,
    JSON.stringify(categoryList)
  )
}
